import { IShop } from "interfaces";
import Image from "next/image";
import FlashlightFillIcon from "remixicon-react/FlashlightFillIcon";
import { useTranslation } from "react-i18next";
import { getSchedule } from "utils/getShopTodaySchedule";
import Link from "next/link";
import cls from "./shopVerticalCard.module.scss";
import { shopHref } from "utils/shopHref"; // ✅ aggiunto import

type Props = {
  data: IShop;
};

export default function ShopVerticalCard({ data }: Props) {
  const { t } = useTranslation();
  const today = getSchedule(data);

  return (
    <Link href={shopHref(data)} className={cls.container}> {/* ✅ URL SEO-friendly */}
      <div className={cls.imageContainer}>
        <Image
          src={data?.logo_img || ""}
          alt={data?.translation?.title}
          fill
          quality={90}
          sizes="80px"
        />
      </div>
      <div className={cls.body}>
        <h1 className={cls.title}>{data?.translation?.title}</h1>
        <p className={cls.description}>
          <FlashlightFillIcon size={13} />
          <span>
            {!today?.disabled && data?.open
              ? `${t("by")} ${today?.from || t("N/A")}`
              : t("closed")}
          </span>
        </p>
      </div>
    </Link>
  );
}
